<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <div class="layout-container">
        <slot></slot>
    </div>
</template>

<style>
.layout-container {
    @apply tw-w-full tw-min-h-screen tw-h-max tw-grid tw-grid-cols-12 tw-relative;
}
</style>
